/**
 * <cafecito-reveal> custom element
 * Scroll-reveal animation: fades + slides content in when it enters the viewport.
 * Loaded as a theme asset so it always runs regardless of {% javascript %} bundling.
 */
(function () {
  'use strict';

  class CafecitoReveal extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.classList.add('revealed');
        return;
      }

      const delay = this.dataset.delay || '0';
      this.style.setProperty('--reveal-delay', delay + 'ms');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('revealed');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08 }
      );

      observer.observe(this);
    }
  }

  if (!customElements.get('cafecito-reveal')) {
    customElements.define('cafecito-reveal', CafecitoReveal);
  }
})();
